module.exports = {
	'customFolder.m4.m410140_browse': {
		'assessmentYear': 'Year',
		'assessmentPeriod': 'Period',
		'assessmentScore': 'Scores',
		'isItApproved': 'Status',
		'through': 'Passed',
		'notPassed': 'Failed',
		'assessmentType': 'Category',
		'assessmentLevelRegulations': 'Level rule',
		'assessmentLevel': 'Level',
		'comment': 'Comment',
		'assessmentStage': 'Evaluation Phase',
		'supervisorSName': 'Supervisor',
		'assessmentPersonnel': 'Evaluator',
		'stageScore': 'Phase scores',
		'stageAssessmentLevelRules': 'Phase level rule',
		'stageAssessmentLevel': 'Phase level',
		'assessmentPlanName': 'Phase title',
		'nonEmployee': 'Non-employee',
	},
	'customFolder.m4.m410140': {
		'assessmentManagementName': 'Title',
		'startOfTheYear': 'Start',
		'yearToDate': 'End',
	},
	'customFolder.service.m3.service-m310250': {
		'supervisorSAffiliatedCompany': "Supervisor's company",
		'theCompanyToWhichTheAssessor': "Evaluator's company",
		'staffPerformanceRecordDetails': 'Subordinate Performance Records',
	},
};
